import { RefreshResponse } from "../entities/CreditSummaryEntity";
import { CreditsRepository } from "../repositories/CreditsRepository";

export class RefreshVendorCreditsCacheUseCase {
  constructor(private repository: CreditsRepository) {}

  async execute(): Promise<RefreshResponse> {
    return await this.repository.refreshVendorCreditsCache();
  }
}

